import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "role_delete_confirm",
  ref: "newTargetModalDel",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content rounded" }
const _hoisted_4 = { class: "modal-header py-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "fs-5 fw-bold mb-3" }, "Eliminar rol", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "isax-close-circle text-white fs-2" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "mb-13 fs-base" }
const _hoisted_10 = { class: "text-decoration-underline" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = ["data-kt-indicator"]
const _hoisted_13 = {
  key: 0,
  class: "indicator-label fs-base"
}
const _hoisted_14 = {
  key: 1,
  class: "indicator-progress fs-base"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", {
            class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            id: "kt_modal_new_target_form",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            class: "form"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", null, [
                  _createTextVNode(" ¿Deseas eliminar el rol: "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.name), 1),
                  _createTextVNode("? Los datos serán eliminados y no se podrá deshacer. ")
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "btn btn-lg btn-secondary me-5 fs-base",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
                }, " Cancelar "),
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Eliminar rol "))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                        _createTextVNode(" Eliminando... "),
                        _hoisted_15
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_12)
              ])
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 512))
}